import React from "react";
import { Empty } from "antd";
import { formatPercentage, StatusTag } from "../../../assets/utils/reportUtils";
import CommonTable from "../../../components/shared/table/Table";
import { getMemberCourseColumns } from "../../../utility/coloumnConstants";


const CurriculumCoursesTable = ({ courses, rowKeyPrefix = "" }) => {
  if (!courses || courses.length === 0) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No courses found." />;
  }

  return (
    <CommonTable
      data={courses}                         
      columns={getMemberCourseColumns()}
      pagination={false}
      rowKey={(record) => `${rowKeyPrefix}course-${record.courseId}`}
    />
  );
};

export default CurriculumCoursesTable;